import axios from '../merchantPortalService';

export const getOffersByAppId = async (appId: string) => {
  try {
    const response = await axios.get(`/api/v1/iso/${appId}`);
    const { data } = response;
    if (data.length) {
      return data;
    }
  } catch (error: any) {
    console.error(error);
    return [];
  }
};

// eslint-disable-next-line no-unused-vars
export const getOffersByDealID = async (dealId: string) => {
  try {
    const response = await axios.get(`/api/v1/deals/${dealId}/offers`);
    const { data } = response;
    if (data.length) {
      return data;
    }
  } catch (error: any) {
    console.error(error);
    return [];
  }
};

// eslint-disable-next-line no-unused-vars
export const fetchIsoSubmittedApplications = async (params?: {
  pageSize?: number;
  page?: number;
}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    if (params?.page) queryParams.append('page', params.page.toString());

    const response = await axios.get(
      `/api/v1/application/iso/applications?${queryParams.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching ISO submitted applications:', error);
    return {
      data: [],
      total: 0,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
    };
  }
};

// eslint-disable-next-line no-unused-vars
export const fetchIsoFundedDeals = async (params?: { pageSize?: number; page?: number }) => {
  try {
    const queryParams = new URLSearchParams();
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    if (params?.page) queryParams.append('page', params.page.toString());

    const response = await axios.get(`/api/v1/deals/iso/funded-deals?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching ISO funded deals:', error);
    return {
      data: [],
      total: 0,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
      hasNextPage: false,
    };
  }
};

// Fetch partner info by ISO ID
export const fetchPartnerByIsoId = async (isoId: string) => {
  try {
    const response = await axios.get(`/api/v1/partners/${isoId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching partner by isoId:', error);
    return null;
  }
};

// Convenience helper to extract the primary partner manager's basic user info
export const fetchPrimaryPartnerManager = async (
  isoId: string
): Promise<{
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber?: string;
} | null> => {
  const partnerResponse = await fetchPartnerByIsoId(isoId);
  const managers = partnerResponse?.data?.partnerManagers || [];
  if (!Array.isArray(managers) || managers.length === 0) return null;

  const primaryManager = managers.find((m: any) => m?.isPrimary) || managers[0];
  const user = primaryManager?.user;
  if (!user) return null;

  return {
    firstName: user.firstName,
    lastName: user.lastName,
    emailAddress: user.emailAddress,
    phoneNumber: user.phoneNumber,
  };
};
